import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  PURCHASE_ORDERS_REPORT_GET_JOB_LIST: createSagaAction('PURCHASE_ORDERS_REPORT_GET_JOB_LIST'),
  PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST: createSagaAction(
    'PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST'
  ),
  PURCHASE_ORDERS_REPORT_GET_FULL_REPORT: createSagaAction('PURCHASE_ORDERS_REPORT_GET_FULL_REPORT')
}

// Action Creators
export const actions = {
  purchaseOrdersReportGetJobList: ({ filters }) => ({
    type: constants.PURCHASE_ORDERS_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  purchaseOrdersReportGetCompaniesList: () => ({
    type: constants.PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST.ACTION
  }),
  purchaseOrdersReportGetFullReport: ({ filters }) => ({
    type: constants.PURCHASE_ORDERS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.PURCHASE_ORDERS_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.PURCHASE_ORDERS_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST.ACTION:
      return { ...state, error: null, loadingCompaniesList: true }
    case constants.PURCHASE_ORDERS_REPORT_GET_COMPANIES_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingCompaniesList: false,
        companiesList: action.payload
      }

    case constants.PURCHASE_ORDERS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.PURCHASE_ORDERS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/general/purchaseOrdersReportActions.js